<template>
	<v-app id="">
		<Overlay />
		<ModalRequestError />
		<v-content>
			<v-container fluid fill-height>
				<v-layout align-center justify-center>

					<v-flex xs12 sm8 md4>
						<v-layout row wrap align-center justify-center>
							<v-flex xs5 md5 align-center justify-center class="mb-12">
								<v-img src="/img/logo.png" align-center width="250px" justify-center></v-img>
							</v-flex>
						</v-layout>
						<v-alert dense border="left" type="warning" v-model="message">
							Enviamos um link de recuperação para seu e-mail.
						</v-alert>

						<v-card outlined>
							<v-toolbar flat>
								<v-toolbar-title> <span class="font-weight-bold with0" style="font-size: 16pt">Recuperar
										senha</span></v-toolbar-title>
								<v-spacer></v-spacer>
								<v-btn color="primary" @click="$router.push({name: 'login'})" outlined>Entrar</v-btn>
							</v-toolbar>
							<v-form ref="formRecuperarSenha">
								<v-card-text>
										<v-text-field outlined dense label="E-mail" v-model="data.email" type="text"
											autocomplete="new-name" :rules="rules.email"></v-text-field>
								</v-card-text>
								<v-card-actions>
									<v-btn @click="store" color="success" block="" outlined>Recuperar</v-btn>
								</v-card-actions>
							</v-form>
						</v-card>
					</v-flex>
				</v-layout>
			</v-container>
		</v-content>
	</v-app>
</template>

<script>
	import ModalRequestError from '@/components/shared/ModalRequestError'
	import Overlay from '@/components/shared/Overlay'

	export default {
		props: {
			source: String,
		},
		components: {
			ModalRequestError,
			Overlay
		},
		data() {
			return { 
				drawer: null,
				data: {
					email: '',
				},
				message: false,
				rules: {
					email: [
						v => !!v || 'Campo obrigatório.'
					],
				}
			}
		},

		methods: {
			store() {
				if (this.$refs.formRecuperarSenha.validate()) {

					this.$store.commit('setOverlay', true)
					this.$http.post(`${this.$urlApi}/password/create`, this.data)
						.then(res => {
							this.$store.commit('setOverlay', false)
							this.message = true;
							// this.$toastr.success('Cadastro efetuado com sucesso');
							// this.$router.push({'name':'login'})
						})
						.catch(e => {
							this.$store.commit('setOverlay', false)

							let stringErrors = [];

							Object.keys(e.response.data.errors).map(value => {
								return stringErrors.push(`${e.response.data.errors[value]}`);
							});

							this.$store.dispatch("showModalRequestError", stringErrors)
						})
				}

			}
		},
		created() {
			let user = this.$store.getters.getUser;
			if (user) {
				this.$router.push({ name: "home" });
			}
		}
	}
</script>

<style scoped>
	#inspire {
		background: linear-gradient(to right, #232526, #414345);
	}
</style>